import { debouncePromise } from '@flamingo_tech/funkgo-utils/promiseUtils'
import composeInstallation from '../utils/composeInstallation'

const installAppleSDk = composeInstallation({
  name: 'appleLogin',
  makeScriptUri: () => 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
})

const install = debouncePromise(installAppleSDk)

const init = () => {

  if (window.AppleLogin) {
    return window.AppleLogin
  }

  window.AppleLogin = install()

  return window.AppleLogin

}

export {
  init
}